import { _TEST1234 } from "../config/ApiConfig";
import TancisPortalMain from "./PortalMain/TancisPortalMain";
import TaneswPortalMain from "./PortalMain/TaneswPortalMain";
import TanogaPortalMain from "./PortalMain/TanogaPortalMain";

const PortalMain = () => {
    switch (_TEST1234.SYSTEM_GROUP_ORI) {
        case "tancis":
            return <TancisPortalMain />;
        case "tanesw":
            return <TaneswPortalMain />;

        // OGA 포탈 메인 컴포넌트입니다
        // ./PortalMain/TanogaPortalMain
        case "tanoga":
            return <TanogaPortalMain />;
        default:
            return null;
    }
};

export default PortalMain;
